export default __webpack_public_path__ + "static/media/cs_icon_01_on.78f3bd82.png";